<template>
  <v-container fluid class="align-start pa-0 fill-height">
    <div class="d-flex flex-column w-100" style="width: 100%; height: 100%;">
      <div class="text-start mb-3" style="min-height: 40px; display: flex; align-items: center;">
        <span class="text-h5 textLight--text font-weight-bold">
          {{ $t("notifications.notifications") }}
        </span>
      </div>

      <v-card class="modern-notif-card pa-4 flex-grow-1 d-flex flex-column justify-center" style="min-height: 332px;">
        <v-row v-if="loading" align="center" justify="center">
          <v-col class="text-center">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>

        <v-row v-else-if="hasLoadingError" align="center" justify="center">
          <v-col class="text-center">
            <div class="subtitle-1 text-capitalize hand-cursor">
              <v-icon color="error"> mdi-replay </v-icon>
              <p class="mb-0 mt-1">{{ $t("retry") }}</p>
            </div>
          </v-col>
        </v-row>

        <template v-else-if="notifications">
          <div v-if="notifications.length" class="align-self-start" style="width: 100%;">
            <v-row
              v-for="(data, index) in notifications"
              :key="`notification_simple_${index}`"
              align="start"
            >
              <v-col cols="12" class="py-2">
                <NotificationAlert :data="data" />
              </v-col>
            </v-row>

            <v-row v-if="totalNotificationsCount > 3">
              <v-col cols="12" class="py-0">
                <div class="d-flex justify-end subtitle-2 primary--text">
                  <p @click="navigateToNotificationsPage" class="ma-0 hand-cursor font-weight-medium">
                    {{ $t("user.registration.viewAll") }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </div>

          <div v-else class="text-center py-8">
            <div
              class="d-inline-flex align-center justify-center mb-3"
              style="width: 56px; height: 56px; border-radius: 50%; background-color: #eff6ff;"
            >
              <v-icon color="primary" size="28">mdi-bell-check-outline</v-icon>
            </div>
            <div class="subtitle-1 font-weight-medium textLight--text">
              {{ $t("notifications.noNotifications") }}
            </div>
            <div class="caption" style="color: #64748b;">
              You're all caught up!
            </div>
          </div>
        </template>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import NotificationAlert from "@/app/core-module/components/NotificationAlert";

export default {
  name: "NotificationAlertList",
  components: { NotificationAlert },
  data() {
    return {
      loading: true,
      hasLoadingError: false,
      notifications: null,
      totalNotificationsCount: 0,
    };
  },
  apollo: {
    getNotifications() {
      return {
        query: require("../api/query/getNotifications.gql"),
        variables: {
          pageInput: {
            skip: 0,
            limit: 10,
          },
        },
        result({ data, loading }) {
          if (data?.getNotifications?.notifications) {
            this.notifications = data?.getNotifications?.notifications?.slice(
              0,
              3
            );

            this.totalNotificationsCount = data?.getNotifications.totalCount;
          } else {
            this.hasLoadingError = true;
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    navigateToNotificationsPage() {
      this.$router.push({
        name: "Notifications",
      });
    },
  },
};
</script>

<style scoped>
.modern-notif-card {
  border-radius: 14px !important;
  background: #ffffff !important;
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 2px 12px 0 rgba(15, 23, 42, 0.04) !important;
}
</style>
